var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-main',{attrs:{"showAbout":_vm.showAbout},on:{"close-about":function($event){return _vm.$emit('close-about')},"open-signup":function($event){return _vm.$emit('open-signup')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }